import PropTypes from 'prop-types';
import React from 'react';
import DateRangePicker from 'react-daterange-picker';
import { Button, ButtonToolbar } from 'react-bootstrap';
import moment from 'moment';

import HotelList from './HotelList';
import HotelMap from './HotelMap';
import HotelAddModal from './HotelAddModal';
import HotelDetailModal from './HotelDetailModal';
import { findByUID } from '../../../core/utils';
import HotelDefineBid from './HotelDefineBid';
import Definebidgrid from './Definebidgrid'
import { Modal } from 'react-bootstrap';

class HotelBuildBid extends React.Component {
  constructor(props) {
    super(props);

    const focusedInput = null;

    this.state = {
      focusedInput,
      startDate: moment(props.event.start),
      endDate: moment(props.event.end),
      viewMap: false,
      showAddHotel: false,
      showHotelDetail: false,
      showHotelDefineBid: false,
      showAlertWindow: false,
      isOpen: false,
      groupId: [],
      eventId:[],
    };
    this.onDatesChange = this.onDatesChange.bind(this);
    this.onFocusChange = this.onFocusChange.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.closeHotelDetailModal = this.closeHotelDetailModal.bind(this);
    this.handleViewToggle = this.handleViewToggle.bind(this);
    this.handleStayToggle = this.handleStayToggle.bind(this);
    this.handleAddHotel = this.handleAddHotel.bind(this);
    this.handleDisplayHotel = this.handleDisplayHotel.bind(this);
    this.handleDisplayDefineBid = this.handleDisplayDefineBid.bind(this);
    this.closeHotelDefineBidModal = this.closeHotelDefineBidModal.bind(this);
    this.handleshowAlertWindow = this.handleshowAlertWindow.bind(this);
    this.closeAlertWindow = this.closeAlertWindow.bind(this);
    this.onSetCheckInOutDates = this.onSetCheckInOutDates.bind(this);
    this.toggleCalendar = this.toggleCalendar.bind(this);
    this.onDateRangeSelect = this.onDateRangeSelect.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }
  componentWillReceiveProps(nextProps) {
    // if (nextProps.needFetch && nextProps.event.event_type === 'stay') {
    //   this.startHotelSearch(nextProps);
    // }
  }

  componentWillMount() {
    document.addEventListener('mousedown', this.handleClick, false);
    if (this.props.needFetch && this.props.event.event_type === 'stay') {
      this.startHotelSearch(this.props);
    }
  }
  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClick, false); // Remove the event listener
  }
  handleClick = (e) => {
    const { groupId ,eventId} = this.state;
    const {group_id,event_id} = this.props;
    // Add the event value to the array
    this.setState(prevState => ({
      groupId: [group_id],
      eventId:[event_id]

    }));
    // if (this.node.contains(e.target) || e.target.id == "selectHotelDateRange") {
    //   return;
    // }
    // this.handleClickOutside();
  }  
  handleClickOutside() {
    this.setState({
      isOpen: !this.state.isOpen
    })
  }
  onFocusChange(focusedInput) {
    this.setState({ focusedInput });
  }
  onDatesChange({ startDate, endDate }) {
    this.setState({ startDate, endDate });
    const payload = {
      start: startDate.format('YYYY-MM-DD'),
      end: endDate.format('YYYY-MM-DD'),
    };
    this.props.editGroupEvent(this.props.event.id, payload);
  }
  onSetCheckInOutDates(startDate, endDate, eventId){
    const payload = {
     start: startDate,
     end: endDate
    };
    startDate = moment(startDate);
    endDate = moment(endDate);
    this.setState({
     startDate: startDate,
     endDate: endDate
    })
    this.props.editGroupEvent(eventId, payload);
  }
  startHotelSearch(props) {
    this.props.searchHotels(props.event.id);
    this.props.requestquestions();
    const startDate = moment(props.event.start);
    const endDate = moment(props.event.end);
    this.setState({ startDate, endDate });
  }
  closeModal() {
    this.setState({
      showAddHotel: false,
    });
  }
  closeHotelDetailModal() {
    this.setState({
      showHotelDetail: false,
    });
  }
  handleViewToggle(e) {
    e.preventDefault();
    this.setState({ viewMap: !this.state.viewMap });
  }
  handleStayToggle(e) {
    e.preventDefault();
    const payload = {};
    if (this.props.event.event_type === 'stay') {
      payload.event_type = 'nost';
    } else if (this.props.event.event_type === 'nost') {
      payload.event_type = 'stay';
    }
    this.props.editGroupEvent(this.props.event.id, payload);
  }
  handleAddHotel(e) {
    e.preventDefault();
    this.setState({
      showAddHotel: true,
    });
  }

  handleDisplayHotel(hotel) {
    this.setState({
      hotel: this.findHotel(hotel),
      showHotelDetail: true,
    });
  }
  findHotel(id) {
    const idx = this.props.hotels.findIndex(findByUID, id);
    if (idx === -1) {
      console.log('that should not happen... findHotel', id);
      return {};
    }
    return this.props.hotels[idx];
  }
  handleDisplayDefineBid() {
    this.setState({ showHotelDefineBid: true })
  }
  closeHotelDefineBidModal() {
    this.setState({ showHotelDefineBid: false })
  }
  handleshowAlertWindow() {
    this.setState({ showAlertWindow: true })
  }
  closeAlertWindow() {
    this.setState({ showAlertWindow: false })
  }
  toggleCalendar() {
    this.setState({ isOpen: !this.state.isOpen });
  }
  onDateRangeSelect = (value, states) => {
    this.setState({
      startDate: value.start,
      endDate: value.end
    })
    const payload = {
      start: value.start.format('YYYY-MM-DD'),
      end: value.end.format('YYYY-MM-DD'),
    };
    this.props.editGroupEvent(this.props.event.id, payload);
    this.setState({
      isOpen: false
    })
  };
  render() {
    const { focusedInput, startDate, endDate } = this.state;
    const dateRange = moment.range(startDate, endDate);
    const { groupId,eventId } = this.state;
    if (this.props.event.event_type !== 'stay') {
      return (
        <div className="center-block col-sm-6 no-hotel">
          <p>No hotel for this group at this location.</p>
          <Button onClick={this.handleStayToggle}>
            <span className="fa-stack fa-lg">
              <i className="fa fa-square fa-stack-2x" />
              <i className="fa fa-stack-1x fa-hotel fa-inverse" />
            </span>
            Add Hotel
          </Button>
        </div>
      );
    }
    let viewButton = (
      <Button onClick={this.handleViewToggle}>
        <span className="fa-stack fa-lg">
          <i className="fa fa-square fa-stack-2x" />
          <i className="fa fa-stack-1x fa-map-marker fa-inverse" />
        </span>
        Map
      </Button>
    );
    let hotelView = (
      <HotelList
        hotels={this.props.hotels}
        eventId={this.props.event.id}
        favoriteHotel={this.props.favoriteHotel}
        requestBidsets={this.props.requestBidsets}
        selectHotel={this.props.selectHotel}
        place={this.props.event.place}
        displayHotel={this.handleDisplayHotel}
        groupId={this.props.event.group}
        selectTourId={this.props.selectedTourId}
        event={this.props}
        displayError={this.handleshowAlertWindow}
      />
    );
    if (this.props.isFetching) {
      hotelView = (
        <p className="text-center">
          <i className="fa fa-spinner fa-spin fa-3x fa-fw" />
          <span className="sr-only">Loading hotels...</span>
          <br />Catch is searching for hotels!
        </p>
      );
    }
    if (this.state.viewMap) {
      viewButton = (
        <Button onClick={this.handleViewToggle}>
          <span className="fa-stack fa-lg">
            <i className="fa fa-square fa-stack-2x" />
            <i className="fa fa-stack-1x fa-table fa-inverse" />
          </span>
          Table
        </Button>
      );
      hotelView = (
        <HotelMap
          hotels={this.props.hotels}
          groupId={this.props.event.group}
          eventId={this.props.event.id}
          favoriteHotel={this.props.favoriteHotel}
          selectHotel={this.props.selectHotel}
          place={this.props.event.place}
        />
      );
    }

    return (
      <div>
        <div>
          <Definebidgrid
            currentEventDate={this.props.currentEvent[0].start}
            city_details={this.props.selectedTour.tour.tour_stops}
            city_notes={this.props.selectedTour.tour.city_notes}
            requestBidsets={this.props.requestBidsets}
            city_id ={this.props.city_id} 
            event_id={eventId}
            saveCityNotes={this.props.saveCityNotes}
            DeleteEventNotes={this.props.DeleteEventNotes}
            group_id = {groupId}
            bidsvalue={this.props.bidsvalue}
            {...this.props}
          />
        </div>
        {/* <div className="info-panel spacing">
          <div id="selectHotelDateRange" onClick={this.toggleCalendar}>
            {startDate.format("MMM DD, YYYY")}
            {" - "}
            {endDate.format("MMM DD, YYYY")}
          </div>
          {this.state.isOpen &&
            (<div className="select-hotel-date-range-picker-section" ref={node => this.node = node}>
              <DateRangePicker
                numberOfCalendars={2}
                value={dateRange}
                singleDateRange={true}
                minimumDate={moment.now()}
                onSelect={this.onDateRangeSelect}
                showLegend={true}
                selectedLabel=" Click on month/year to select month/year quickly"
              />
            </div>)}
          <Button bsStyle="warning" onClick={this.handleDisplayDefineBid}>
            <span className="fa-stack fa-lg">
              <i className="fa fa-arrow-circle-left" />
            </span>
            Define Bid
          </Button>
        </div> */}
        <div>
          <hr className='grid-line' ></hr>
          <div className="info-panel spacing">
            <Button onClick={this.handleStayToggle}>
              <span className="fa-stack fa-lg">
                <i className="fa fa-hotel fa-stack-1x" />
                <i className="fa fa-ban fa-stack-2x" />
              </span>
              No Hotel
            </Button>
            {viewButton}
            <Button onClick={this.handleAddHotel}>
              <span className="fa-stack fa-lg">
                <i className="fa fa-square fa-stack-2x" />
                <i className="fa fa-stack-1x fa-plus fa-inverse" />
              </span>
              Add Hotel
            </Button>
            <Button onClick={this.props.showPrefs} title="Show Hotel Search Preferences">
              <span className="fa-stack fa-lg">
                <i className="fa fa-square fa-stack-2x" />
                <i className="fa fa-stack-1x fa-cog fa-inverse" />
              </span>{' '}
              Search Preferences
            </Button>
          </div>
          <div className="planner">
            {hotelView}
            {this.state.showAddHotel && (
              <HotelAddModal
                event={this.props.event.id}
                show={this.state.showAddHotel}
                onClose={this.closeModal}
                displayHotel={this.handleDisplayHotel}
                event={this.props}
                existingHotelsList={this.props.hotels}
                displayError={this.handleshowAlertWindow}
              />
            )}
            {this.state.showHotelDetail && (
              <HotelDetailModal
                hotel={this.state.hotel}
                show={this.state.showHotelDetail}
                onClose={this.closeHotelDetailModal}
              />
            )}

            {this.state.showAlertWindow && (<Modal show={this.state.showAlertWindow} onHide={this.closeAlertWindow}>
              <Modal.Header closeButton>
                <Modal.Title>Define Bid</Modal.Title>
              </Modal.Header>
              <Modal.Body>

                <p> Please define  bid before selecting Hotels.</p>

                <ButtonToolbar style={{ float: 'right' }}>
                  <Button
                    bsStyle="success"
                    onClick={this.closeAlertWindow}
                  >
                    Ok
                  </Button>
                </ButtonToolbar>
              </Modal.Body>
              <Modal.Footer style={{ clear: 'both' }} />
            </Modal>
            )}

          </div>
        </div>
        {this.state.showHotelDefineBid && (<HotelDefineBid
          {...this.props}
          show={this.state.showHotelDefineBid}
          onClose={this.closeHotelDefineBidModal}
          onSetCheckInOutDates={this.onSetCheckInOutDates}
        />
        )}

      </div>
    );
  }
}

HotelBuildBid.propTypes = {
  hotels: PropTypes.arrayOf(PropTypes.object).isRequired,
  needFetch: PropTypes.bool.isRequired,
  isFetching: PropTypes.bool.isRequired,
  event: PropTypes.object.isRequired,
  searchHotels: PropTypes.func.isRequired,
  selectHotel: PropTypes.func.isRequired,
  favoriteHotel: PropTypes.func.isRequired,
  editGroupEvent: PropTypes.func.isRequired,
  // showPrefs: PropTypes.func.isRequired,
  requestquestions: PropTypes.func.isRequired,
};

HotelBuildBid.defaultProps = {
  hotels: [],
};
export default HotelBuildBid;



// WEBPACK FOOTER //
// src/routes/tours/components/HotelBuildBid.js